//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { detailImportJob } from "@/api/customerCenter/customerCenter";
export default {
  name: "writeDocumentDetail",
  data: function data() {
    return {
      dialog: false,
      pramsData: {}
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      if (data) {
        this.getDetail(data);
      }

      this.dialog = true;
    },
    getDetail: function getDetail(data) {
      var _this = this;

      detailImportJob({
        job_id: data.job_id,
        game: data.game,
        server_id: data.server_id
      }).then(function (res) {
        if (res.status == 'ok') {
          _this.pramsData = res.item;
        }
      });
    },
    resetForm: function resetForm() {
      this.dialog = false;
      this.clearData();
    },
    clearData: function clearData() {
      this.pramsData = {};
    }
  }
};